import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";
import BaseTable from "@/components-UI/table/BaseTable.vue";
import { ITableHeader, showServerError } from "@/utils";
import { CellsType, prepareItems, RawConfig } from "@/utils/CellsFactory";
import { translateEarlyReleaseConfirmationStatus, translateEarlyReleaseProcessingStatus } from "@/utils/translate";
import { IAffiliateInvoice, IEmployeePayment } from "@/api/types/payout";
import { getPayments } from '@/api/payout';

type ConfigType = IEmployeePayment & { partner: any, master_account: any, payment_method: any, created_by: any };

export default /*#__PURE__*/_defineComponent({
  __name: 'EarlyRelease',
  props: {
    invoice: null
  },
  setup(__props: any) {

const props = __props as {
    invoice: IAffiliateInvoice,
}



const items = ref([]);
const headers: ITableHeader[] = [
    { text: 'ID', value: 'id', width: '80px', align: 'center' },
    { text: 'Кем создано', value: 'created_by', width: 'auto' },
    { text: 'Партнёр', value: 'partner', width: 'auto' },
    { text: 'Мастер-аккаунт', value: 'master_account', width: 'auto' },
    { text: 'Сумма', value: 'paid_sum', align: 'right', width: '150px' },
    { text: 'Валюта', value: 'currency', width: '80px', align: 'center' },
    { text: 'Период', value: 'period', width: '140px' },
    { text: 'Способ выплаты', value: 'payment_method', width: '120px' },
    { text: 'Реквизиты', value: 'requisite', width: 'auto' },
    { text: 'Дата создания', value: 'created_at', width: '150px', align: 'right' },
    { text: 'Статус подтверждения', value: 'status_confirmation', width: '150px', align: 'center' },
    { text: 'Статус обработки', value: 'status', width: '150px', align: 'center' },
];

const config: RawConfig<ConfigType> = {
    [CellsType.Route]: {
        id: {
            name: 'payment',
            valueKey: 'id',
            text: 'id',
            isChip: true,
        },
        partner: {
            name: 'payment',
            valueKey: 'id',
            text: (i) => {
                const affiliate = i.affiliate;
                return affiliate ? `${affiliate.account_id} ${affiliate.name}` : '';
            },
        },
        master_account: {
            name: 'payment',
            valueKey: 'id',
            text: (i) => {
                const affiliate = i.affiliate;
                return affiliate ? `${affiliate.master_id} ${affiliate.name}` : '';
            },
        },
    },
    [CellsType.Text]: {
        created_by: {
            template: (i) => i.by_manager ? 'Менеджер' : 'Партнёр',
        },
        payment_method: {
            template: (i) => typeof i.method_name ? i.method_name : i.method_name.ru,
        },
        requisite: {
            template: (i) => typeof i.requisite === 'string' ? i.requisite : i.requisite.partner_data.account_id,
        },
    },
    [CellsType.Number]: {
        paid_sum: {},
    },
    [CellsType.Date]: {
        period: {
            format: 'dd MMMM yyyy',
            isHideTime: true,
        },
        created_at: {
            format: 'dd.MM.yyyy',
        },
    },
    [CellsType.Status]: {
        status_confirmation: {
            translate: (s: string | boolean) => translateEarlyReleaseConfirmationStatus(String(s)),
        },
        status: {
            translate: (s: string | boolean) => translateEarlyReleaseProcessingStatus(String(s)),
        },
    },
};

const formattedItems = computed(() => prepareItems(items.value, config, headers.map(h => h.value)));

watch(() => props.invoice?.id, async (id: number) => {
    if (id) {
        try {
            const resp = await getPayments({ invoice_ids: [id] });
            items.value = resp.data;
        } catch (e) {
            showServerError(e, 'Досрочки не получены!');
        }
    }
}, { immediate: true });

return { __sfc: true,props, items, headers, config, formattedItems, BaseEditableCard, BaseTable }
}

})